import Footer from "../Footer";
import Header from "../Header";

const ThankYouPage = ({ page }) => {
  return (
    <>
      <Header />
      <div className="thanks-page">
        <h2
          style={{
            background: "linear-gradient(90deg, #ED9C17 12.5%, #CD495B 100%)",
            WebkitBackgroundClip: "text",
            color: "transparent",
          }}
        >
          {page === "register"
            ? "Thank you for joining Flying Help!"
            : page === "forgotPassword"
            ? "Mail sent successfully!"
            : "Thank you for contacting us!"}
        </h2>

        {page === "register" && (
          <div className="thanks-page-div">
            <p>We are excited to have you onboard.</p>
            <p>
              To complete your registration, please verify your email address.
            </p>
            <a
              className="learn-more"
              href="https://mail.google.com/"
              target="_blank"
              rel="noopener noreferrer"
            >
              Open Gmail
            </a>
          </div>
        )}
        {page === "contact" && (
          <div className="thanks-page-div">
            <p>We will reach to you soon.</p>
            <a className="learn-more" href="/">
              Back to Home
            </a>
          </div>
        )}

        {page === "forgotPassword" && (
          <div className="thanks-page-div">
            <p>To update your password, please verify your email address.</p>
            <a
              className="learn-more"
              href="https://mail.google.com/"
              target="_blank"
              rel="noopener noreferrer"
            >
              Open Gmail
            </a>
          </div>
        )}
      </div>
      <Footer />
    </>
  );
};

export default ThankYouPage;
